import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { persistStore } from "redux-persist";
import createSagaMiddleware from "redux-saga";
import { all } from "redux-saga/effects";

import * as Sentry from "@sentry/react";

import { appActionTypes } from "./actions";
import appReducer from "./app/reducer";
import appSaga from "./app/saga";
import prpReducer from "./prp/reducer";
import prpSaga from "./prp/saga";
import userReducer from "./user/reducer";

function* rootSaga() {
  yield all([appSaga(), prpSaga()]);
}

const rootReducer = combineReducers({
  app: appReducer,
  prp: prpReducer,
  user: userReducer,
});

export const composeEnhancers =
  (window && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const sagaMiddleware = createSagaMiddleware();

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: (action) =>
    action.type === appActionTypes.STORE_LOADING ? null : action,
  stateTransformer: () => null,
});

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware), sentryReduxEnhancer)
);
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

sagaMiddleware.run(rootSaga);
